/* eslint-disable */
/**
 * @note This is an auto-generated file. Do not modify it directly.
 * @see https://devdocs.transfix.io/graphql
 *
 * If you need to update the hooks or definitions in this file:
 * 1. Edit the .graphql file in this directory with the same name
 * 2. Run `npm run generate:graphql:mp` in the terminal
 */

import * as Types from '../../../../../types/graphqlTypes'

import { gql } from '@apollo/client'
import { ShipmentStopBasicInfoFragmentDoc } from './ShipmentStopBasicInfoFragment'
export type IShipmentResponseFragment = { __typename?: 'Shipment' } & Pick<
  Types.IShipment,
  | 'id'
  | 'canCancel'
  | 'carrierApplicationId'
  | 'shipperRateType'
  | 'state'
  | 'truckNumber'
  | 'trailerNumber'
  | 'truckNumberRequired'
  | 'trailerNumberRequired'
  | 'carrierRate'
  | 'vin'
> & {
    activeCarrierAssignment?: Types.Maybe<
      { __typename?: 'CarrierAssignment' } & Pick<
        Types.ICarrierAssignment,
        'id' | 'bounced' | 'trackingMethod'
      > & {
          driver?: Types.Maybe<
            { __typename?: 'User' } & Pick<
              Types.IUser,
              'id' | 'fullName' | 'parentUserId' | 'email' | 'phone' | 'cellPhone'
            >
          >
          dispatcher?: Types.Maybe<
            { __typename?: 'User' } & Pick<
              Types.IUser,
              'id' | 'fullName' | 'parentUserId' | 'email' | 'phone' | 'cellPhone'
            >
          >
          carrierApplication: { __typename?: 'CarrierApplication' } & Pick<
            Types.ICarrierApplication,
            'id' | 'name' | 'dotNumber' | 'mcNumber' | 'state' | 'fmcsaRating'
          > & {
              headquarter?: Types.Maybe<
                { __typename?: 'Location' } & Pick<Types.ILocation, 'id' | 'city' | 'stateCode'>
              >
              primaryCarrierManager?: Types.Maybe<
                { __typename?: 'User' } & Pick<Types.IUser, 'id' | 'parentUserId' | 'fullName'>
              >
            }
        }
    >
    carrierManager?: Types.Maybe<
      { __typename?: 'User' } & Pick<Types.IUser, 'id' | 'parentUserId' | 'fullName'>
    >
    contactPreferences: { __typename?: 'ContactPreference' } & Pick<
      Types.IContactPreference,
      'carrierContactInstructions'
    >
    coveredBid?: Types.Maybe<
      { __typename?: 'Bid' } & Pick<Types.IBid, 'id' | 'amount' | 'carrierContactUserId'> & {
          carrierAvailableTruck?: Types.Maybe<
            { __typename?: 'CarrierAvailableTruck' } & Pick<
              Types.ICarrierAvailableTruck,
              'id' | 'trailerNumber' | 'truckNumber' | 'vin'
            >
          >
          carrierApplication?: Types.Maybe<
            { __typename?: 'CarrierApplication' } & Pick<
              Types.ICarrierApplication,
              'id' | 'name' | 'dotNumber' | 'mcNumber' | 'state' | 'fmcsaRating'
            > & {
                headquarter?: Types.Maybe<
                  { __typename?: 'Location' } & Pick<Types.ILocation, 'id' | 'city' | 'stateCode'>
                >
                primaryCarrierManager?: Types.Maybe<
                  { __typename?: 'User' } & Pick<Types.IUser, 'id' | 'parentUserId' | 'fullName'>
                >
              }
          >
          carrierContactUser?: Types.Maybe<
            { __typename?: 'User' } & Pick<
              Types.IUser,
              'id' | 'fullName' | 'parentUserId' | 'email' | 'phone' | 'cellPhone'
            >
          >
          driver?: Types.Maybe<
            { __typename?: 'User' } & Pick<
              Types.IUser,
              'id' | 'fullName' | 'parentUserId' | 'email' | 'phone' | 'cellPhone'
            >
          >
        }
    >
    characteristics: { __typename?: 'ShipmentCharacteristics' } & Pick<
      Types.IShipmentCharacteristics,
      | 'backhaulEligible'
      | 'bounceCount'
      | 'hasDropTrailerStops'
      | 'hot'
      | 'mustGo'
      | 'rolloverCount'
      | 'sameDaySpot'
      | 'isHighRisk'
    >
    currentCeRep?: Types.Maybe<
      { __typename?: 'User' } & Pick<Types.IUser, 'id' | 'parentUserId' | 'fullName'>
    >
    equipment: { __typename?: 'Equipment' } & Pick<
      Types.IEquipment,
      'id' | 'key' | 'name' | 'parentKey'
    >
    firstPickup: { __typename?: 'ShipmentStop' } & Pick<
      Types.IShipmentStop,
      'id' | 'city' | 'dropTrailer' | 'stateCode' | 'zipcode'
    >
    lastDelivery: { __typename?: 'ShipmentStop' } & Pick<
      Types.IShipmentStop,
      'id' | 'city' | 'dropTrailer' | 'stateCode' | 'zipcode'
    >
    rateConfirmationAgreement?: Types.Maybe<
      { __typename?: 'RateConfirmationAgreement' } & Pick<
        Types.IRateConfirmationAgreement,
        'id' | 'carrierSignedAt'
      > & { signedBy: { __typename?: 'User' } & Pick<Types.IUser, 'id' | 'fullName'> }
    >
    shipperApplication: { __typename?: 'ShipperApplication' } & Pick<
      Types.IShipperApplication,
      'id' | 'name'
    >
    statusDetails: { __typename?: 'ShipmentStatus' } & Pick<Types.IShipmentStatus, 'detailedState'>
    stops: Array<
      { __typename?: 'ShipmentStop' } & Pick<
        Types.IShipmentStop,
        'id' | 'city' | 'dropTrailer' | 'stateCode' | 'stopType' | 'stopSequence' | 'zipcode'
      >
    >
  }

export const ShipmentResponseFragmentDoc = gql`
  fragment ShipmentResponse on Shipment {
    id
    activeCarrierAssignment {
      id
      bounced
      trackingMethod
      driver {
        id
        fullName
        parentUserId
        email
        phone
        cellPhone
      }
      dispatcher {
        id
        fullName
        parentUserId
        email
        phone
        cellPhone
      }
      carrierApplication {
        id
        name
        dotNumber
        mcNumber
        state
        fmcsaRating
        headquarter {
          id
          city
          stateCode
        }
        primaryCarrierManager {
          id
          parentUserId
          fullName
        }
      }
    }
    canCancel
    carrierApplicationId
    carrierManager {
      id
      parentUserId
      fullName
    }
    contactPreferences {
      carrierContactInstructions
    }
    coveredBid {
      id
      amount
      carrierAvailableTruck {
        id
        trailerNumber
        truckNumber
        vin
      }
      carrierApplication {
        id
        name
        dotNumber
        mcNumber
        state
        fmcsaRating
        headquarter {
          id
          city
          stateCode
        }
        primaryCarrierManager {
          id
          parentUserId
          fullName
        }
      }
      carrierContactUserId
      carrierContactUser {
        id
        fullName
        parentUserId
        email
        phone
        cellPhone
      }
      driver {
        id
        fullName
        parentUserId
        email
        phone
        cellPhone
      }
    }
    characteristics {
      backhaulEligible
      bounceCount
      hasDropTrailerStops
      hot
      mustGo
      rolloverCount
      sameDaySpot
      isHighRisk
    }
    currentCeRep {
      id
      parentUserId
      fullName
    }
    equipment {
      id
      key
      name
      parentKey
    }
    firstPickup {
      ...ShipmentStopBasicInfo
    }
    lastDelivery {
      ...ShipmentStopBasicInfo
    }
    rateConfirmationAgreement {
      id
      carrierSignedAt
      signedBy {
        id
        fullName
      }
    }
    shipperApplication {
      id
      name
    }
    shipperRateType
    state
    statusDetails {
      detailedState
    }
    stops {
      id
      city
      dropTrailer
      stateCode
      stopType
      stopSequence
      zipcode
    }
    truckNumber
    trailerNumber
    truckNumberRequired
    trailerNumberRequired
    carrierRate
    vin
  }
  ${ShipmentStopBasicInfoFragmentDoc}
`
